import moment, { Moment } from "moment";

import { OrderItem, OrderPaymentMethodTypesEnum } from "@/interfaces/domain/Order";
import { formatToWeekDay } from "@/utils/date";

import { DeliveryTimeResult } from "./types";

export const getDeliveryDateDescription = (deliveryTime: DeliveryTimeResult) => {
  if (!deliveryTime) return "";
  if (deliveryTime.isExpressDelivery) {
    return `Express - em até ${deliveryTime?.expressDeliveryTime}hrs`;
  } else {
    return (
      deliveryTime.date &&
      `${formatToWeekDay(deliveryTime.date)}, entre ${deliveryTime.initialHour}hrs e ${
        deliveryTime.finalHour
      }hrs`
    );
  }
};

export const formatPaymentTypeName = (type: string) => {
  const types = {
    credito: "Crédito",
    debito: "Débito",
    dinheiro: "Dinheiro",
  };
  return types[type] || type;
};

export const mapPaymentMethodToOrderPaymentMethod = (type: string) => {
  const types = {
    credito: OrderPaymentMethodTypesEnum.CREDIT,
    debito: OrderPaymentMethodTypesEnum.DEBIT,
    dinheiro: OrderPaymentMethodTypesEnum.CASH,
  };
  return types[type] as OrderPaymentMethodTypesEnum;
};

export const checkItemsOutdateInPromo = (items: OrderItem[], scheduleDate: Date) => {
  let isOutdated = false;
  let newSubtotal = 0;
  const today = moment();
  const isBeforeDate = (dt1: Moment, dt2: Moment) => {
    return dt1.startOf("day").diff(dt2.startOf("day"), "days");
  };
  if (isBeforeDate(today, moment(scheduleDate)) === 0) {
    return {
      isOutdated,
      newSubtotal,
    };
  }
  items.forEach((product) => {
    if (product.item.preco.preco_encarte) {
      if (product.item.data_fim_promo) {
        const dt_fim_promo = new Date(product.item.data_fim_promo);
        dt_fim_promo.setHours(0, 0, 0);
        if (isBeforeDate(moment(scheduleDate), moment(dt_fim_promo)) > 0) {
          isOutdated = true;
          const subtotalCalculado = product.item.preco.preco_original * product.quantidade;
          newSubtotal += subtotalCalculado;
        } else {
          newSubtotal += product.item.preco.preco_encarte * product.quantidade;
        }
      }
    } else {
      newSubtotal += product.item.preco.preco_original * product.quantidade;
    }
  });
  return {
    isOutdated,
    newSubtotal,
  };
};
